$(document).ready(function() {
  /*
   * Agecheck
   */
  window.adult = function (e) {
    var confirmationExpiration = new Date().getTime() + 90*60*60*24*1000; // 90 days
    window.localStorage.setItem( 'age-checker-confirmation', confirmationExpiration );

    checkAge();
    e.preventDefault();
  }

  window.underage = function (e) {
    $('.agecheck__wrap').css({ 'height': $('.agecheck__wrap').outerHeight() });
    $('.agecheck__whatage').fadeOut(700, function () {
      $('.agecheck__underage').fadeIn();
    });
    e.preventDefault();
  }

  function checkAge() {
    var now = new Date().getTime()
    if( ( window.localStorage.getItem( 'age-checker-confirmation' ) !== null
        && window.localStorage.getItem( 'age-checker-confirmation') > now ) ||
        document.referrer.includes( 'https://www.budejovickybudvar.cz/' )  ) {
      document.querySelector('html').classList.add('adult');

      //document.dispatchEvent(new Event('adultLoaded'));
      var event;
      if (typeof (Event) === 'function') {
        event = new Event('adultLoaded');
      } else {
        event = document.createEvent('Event');
        event.initEvent('adultLoaded', true, true);
      }
      document.dispatchEvent(event);

    } else {
      document.querySelector('html').classList.add('agecheck');
      $('#age-verification').addClass('not-verified');
    }
  }

  checkAge();

  /*
   * gLightbox init
   */

  const lightbox = GLightbox({
    videosWidth: '100%',
    autoplayVideos: true,
    plyr: {
      //enabled: !/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
      /* js: 'https://cdn.plyr.io/3.6.3/plyr.polyfilled.js', */
      config: {
        ratio: '16:9',
        muted: false,
        autoplay: true,
        hideControls: true,
        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume'],
        youtube: {
            autoplay: 1,
            noCookie: true,
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            //playsinline: 1
        },
        speed: {
          selected: 1,
          options: [1]
        },
        fullScreen: {
          enabled: true
        }
      },
    },
  });

  // Gligthbox events
  lightbox.on( 'slide_changed', data => {
    if ( data.current.player ) {

      /*
       * Autoplay fix on mobile
       * recognize, whether video is autoplaying - if not, pause it to allow for manual play!
       */

      // pause after 1.5 seconds, if timeout not cleared by playing video
      const autoplayPause = setTimeout( () => {
        data.current.player.pause();
      }, 1500 );

      data.current.player.once( 'progress', e => {
        if ( data.current.player.currentTime > 0 ) clearTimeout( autoplayPause );
      } );


      // Close lightbox on videoend
      data.current.player.on( 'ended', event => {
        setTimeout( () => {
          lightbox.close();
        }, 500 );
      } );
    }
  } );

  /*
   * Initialize Animate on Scroll
   */

  AOS.init({
    duration: 650,
  });
});